var _path, _circle, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSectionPopupSecurityService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_390)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0664 3.30665L20.4039 3.31949C18.5361 3.31949 17.6576 2.73032 16.6391 2.04782C16.2902 1.81449 15.9391 1.57999 15.5494 1.36765C15.0699 1.10632 14.5717 0.986154 14.0036 0.974487C13.4926 0.974487 12.9291 1.10749 12.4484 1.36765C12.0587 1.57999 11.7076 1.81449 11.3587 2.04782C10.3414 2.73032 9.46172 3.31949 7.59389 3.31949L5.93139 3.30665C3.84539 3.30665 2.33105 4.73465 2.33105 6.70282V15.4575C2.33105 21.8532 8.33472 26.3087 11.8044 28.3293C12.3574 28.6595 12.8847 28.971 13.9977 28.9722C15.1107 28.971 15.6381 28.6583 16.1911 28.3293C19.6607 26.3075 25.6644 21.8532 25.6644 15.4575V6.70282C25.6644 4.73465 24.1501 3.30665 22.0641 3.30665H22.0664ZM24.5001 15.4587C24.5001 21.271 18.8476 25.4337 15.5949 27.3295C15.0967 27.627 14.7946 27.8067 14.0001 27.8078C13.2044 27.8078 12.9034 27.627 12.4052 27.3295C9.15256 25.4337 3.50005 21.271 3.50005 15.4587V11.4733H24.5001V15.4587ZM24.5001 10.3067H3.50005V6.70282C3.50005 5.39032 4.49989 4.47332 5.93372 4.47332L7.59622 4.48615C9.81872 4.48615 10.9329 3.73832 12.0097 3.01615C12.3294 2.80149 12.6502 2.58565 13.0072 2.39082C13.3141 2.22282 13.6501 2.15749 14.0036 2.13999C14.3442 2.10265 14.6849 2.22399 14.9917 2.39082C15.3499 2.58565 15.6696 2.80265 15.9892 3.01615C17.0661 3.73832 18.1802 4.48615 20.4027 4.48615L22.0652 4.47332C23.4991 4.47332 24.4989 5.39032 24.4989 6.70282L24.5001 10.3067Z",
    fill: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_394_390)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0001,
    cy: 10.7732,
    r: 4.4,
    fill: "white",
    stroke: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_394_390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 15.4399C14.6126 15.4407 15.2197 15.3204 15.786 15.0858C16.3523 14.8512 16.8666 14.507 17.2995 14.073C17.7335 13.6402 18.0776 13.1258 18.3122 12.5595C18.5468 11.9933 18.6671 11.3862 18.6663 10.7732C18.6671 10.1603 18.5468 9.55323 18.3122 8.98694C18.0776 8.42065 17.7335 7.9063 17.2995 7.47344C16.8666 7.03944 16.3523 6.69527 15.786 6.4607C15.2197 6.22612 14.6126 6.10578 13.9997 6.10657C13.3867 6.10579 12.7797 6.22614 12.2134 6.46072C11.6471 6.69529 11.1327 7.03945 10.6999 7.47344C10.2659 7.9063 9.92173 8.42065 9.68716 8.98694C9.45258 9.55323 9.33223 10.1603 9.33301 10.7732C9.33222 11.3862 9.45257 11.9933 9.68714 12.5595C9.92171 13.1258 10.2659 13.6402 10.6999 14.073C11.1327 14.507 11.6471 14.8512 12.2134 15.0858C12.7797 15.3203 13.3867 15.4407 13.9997 15.4399Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1328 10.7733L13.5328 12.1733L16.3328 9.37329",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_394_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 5.17322H19.5999V16.3732H8.3999V5.17322Z",
    fill: "#72B01D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.973267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_394_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(8.3999 5.17322)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSectionPopupSecurityService);
export default __webpack_public_path__ + "static/media/service_section_popup_security_service.eb542c7f7870d674931b3eab3ce5a530.svg";
export { ForwardRef as ReactComponent };